import { getInvoiceTypeCodeString } from '../../../../../../components/tableTemplates'
import { UblInvoice } from '../../../../../../data/models/_generatedUblInvoice'
import i18n from '../../../../../../utils/i18n'

export const invoiceTypeBodyTemplate = (
  invoiceTypeCode: UblInvoice['InvoiceTypeCode']['Value'],
) => {
  const { t } = i18n

  if (!invoiceTypeCode) return null

  const translation = t(
    `eInvoiceOverview.table.columns.invoiceType.options.${getInvoiceTypeCodeString(
      invoiceTypeCode,
    )}`,
  )

  return <>{translation}</>
}
